function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var y = Object.defineProperty;
var c = Object.getOwnPropertySymbols;
var f = Object.prototype.hasOwnProperty,
    g = Object.prototype.propertyIsEnumerable;

var d = function d(t, o, e) {
  return o in t ? y(t, o, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : t[o] = e;
},
    l = function l(t, o) {
  for (var e in o || (o = {})) {
    f.call(o, e) && d(t, e, o[e]);
  }

  if (c) {
    var _iterator = _createForOfIteratorHelper(c(o)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var e = _step.value;
        g.call(o, e) && d(t, e, o[e]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return t;
};

var a = function a(t, o) {
  var e = {};

  for (var r in t) {
    f.call(t, r) && o.indexOf(r) < 0 && (e[r] = t[r]);
  }

  if (t != null && c) {
    var _iterator2 = _createForOfIteratorHelper(c(t)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var r = _step2.value;
        o.indexOf(r) < 0 && g.call(t, r) && (e[r] = t[r]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return e;
};

import w, { forwardRef as M, useContext as N } from "react";
import { IconContext as P } from "./context.mjs";
var h = M(function (t, o) {
  var m = t,
      e = m.alt,
      r = m.color,
      n = m.size,
      s = m.weight,
      p = m.mirrored,
      u = m.children,
      C = m.weights,
      v = a(m, ["alt", "color", "size", "weight", "mirrored", "children", "weights"]),
      x = N(P),
      _x$color = x.color,
      B = _x$color === void 0 ? "currentColor" : _x$color,
      i = x.size,
      _x$weight = x.weight,
      I = _x$weight === void 0 ? "regular" : _x$weight,
      _x$mirrored = x.mirrored,
      E = _x$mirrored === void 0 ? !1 : _x$mirrored,
      R = a(x, ["color", "size", "weight", "mirrored"]);
  return /* @__PURE__ */w.createElement("svg", l(l({
    ref: o,
    xmlns: "http://www.w3.org/2000/svg",
    width: n != null ? n : i,
    height: n != null ? n : i,
    fill: r != null ? r : B,
    viewBox: "0 0 256 256",
    transform: p || E ? "scale(-1, 1)" : void 0
  }, R), v), !!e && /* @__PURE__ */w.createElement("title", null, e), u, C.get(s != null ? s : I));
});
h.displayName = "IconBase";
var b = h;
export { b as default };